<template>
    <KQuote
        v-editable="blok"
        class="quote"
        :text="blok.text"
        :author="blok.name"
    />
    <div v-html="`<script type='application/ld+json'>${JSON.stringify(structuredData)}</script>`" />
</template>

<script setup>
import { KQuote } from '@vemedia/karibu'

const { blok } = defineProps(['blok'])

const structuredData = computed(() => ({
    '@context': 'Quotation',
    '@type': 'Quotation',
    'creator': {
        '@type': 'Person',
        'name': blok.name,
    },
    'text': blok.text,
}))
</script>

<style lang="scss">
@use 'quote';
</style>
